export default function ChevronBottom() {
    return (
        <svg>
            <use xlinkHref="#chevron-bottom" />
        </svg>
    );
}
